import {
  BentoBrand,
  BentoContact,
  BentoContactResponseType,
  BrandContact,
  OpportunityStage,
  Organization,
  OrganizationProfile,
  Subscription,
  SubscriptionType,
} from "schemas/dashboard";
import { StringMap } from "schemas/functions";

import { ON_BEHALF_OF_TOKEN } from "./localStorage";
import { titleCase } from "./string";

export const REFERRAL_CREDIT = 5;
export const NEW_USER_REFERRAL_CREDIT = 20;

export const getAllStages = (isInfluencer: boolean) => {
  if (isInfluencer) {
    return [
      OpportunityStage.OPPORTUNITIES,
      OpportunityStage.FULFILLING,
      OpportunityStage.COMPLETED,
    ];
  } else {
    return [
      OpportunityStage.NEW,
      OpportunityStage.DISCOVERY,
      OpportunityStage.SCHEDULING_DEMO,
      OpportunityStage.DEMO,
      OpportunityStage.NEGOTIATION,
      OpportunityStage.WON,
      OpportunityStage.LOST,
    ];
  }
};

export const getStageName = (stage: OpportunityStage) => {
  return titleCase(stage);
};

export const getBrandContactName = (contact: BrandContact) => {
  return contact?.name || contact?.title || contact?.email || "";
};

export const hasSocialMediaProfile = (
  organizationProfile: OrganizationProfile | StringMap | null,
) => {
  if (!organizationProfile) {
    return false;
  }
  return (
    organizationProfile?.instagramUrl ||
    organizationProfile?.tiktokUrl ||
    organizationProfile?.youtubeUrl ||
    organizationProfile?.twitchUrl ||
    organizationProfile?.portfolioUrl
  );
};

export const getProfilePlatform = (
  organizationProfile: OrganizationProfile | null,
) => {
  if (organizationProfile?.instagramUrl) {
    return { platform: "Instagram " };
  } else if (organizationProfile?.tiktokUrl) {
    return { platform: "Tiktok " };
  } else if (organizationProfile?.youtubeUrl) {
    return { platform: "YouTube " };
  } else if (organizationProfile?.twitchUrl) {
    return { platform: "Twitch " };
  } else {
    return { platform: "" };
  }
};

export const accessToPartnershipData = (
  currentOrg: Organization | null,
  subscription?: Subscription | null,
) => {
  return (
    currentOrg?.isVaUser ||
    subscription?.partnershipData?.status === SubscriptionType.ACTIVE
  );
};

export const contactReplied = (bentoContact: BentoContact) => {
  return (
    !!bentoContact.bestResponseType &&
    bentoContact.bestResponseType !==
      BentoContactResponseType.no_content_marketing &&
    bentoContact.bestResponseType !== BentoContactResponseType.bounced &&
    bentoContact.bestResponseType !== BentoContactResponseType.automated &&
    bentoContact.bestResponseType !== BentoContactResponseType.wrong_contact &&
    bentoContact.bestResponseType !== BentoContactResponseType.stop_emailing &&
    bentoContact.bestResponseType !== BentoContactResponseType.not_in_company
  );
};

export const contactAskForRates = (bentoContact: BentoContact) => {
  return (
    bentoContact.bestResponseType ===
    BentoContactResponseType.cash_compensation_discussion
  );
};

export const contactDiscussedCollab = (bentoContact: BentoContact) => {
  return (
    bentoContact.bestResponseType ===
      BentoContactResponseType.details_discussion ||
    bentoContact.bestResponseType ===
      BentoContactResponseType.compensation_discussion ||
    bentoContact.bestResponseType === BentoContactResponseType.schedule_call
  );
};

export const contactShowedInterest = (bentoContact: BentoContact) => {
  return (
    bentoContact.bestResponseType === BentoContactResponseType.shared_profile ||
    bentoContact.bestResponseType ===
      BentoContactResponseType.referred_someone_else ||
    bentoContact.bestResponseType ===
      BentoContactResponseType.reach_out_later ||
    bentoContact.bestResponseType ===
      BentoContactResponseType.not_interested_reach_out_later ||
    bentoContact.bestResponseType ===
      BentoContactResponseType.only_tiktok_shop ||
    bentoContact.bestResponseType ===
      BentoContactResponseType.products_or_services_only ||
    bentoContact.bestResponseType ===
      BentoContactResponseType.only_influencer_marketing ||
    bentoContact.bestResponseType === BentoContactResponseType.send_socials ||
    bentoContact.bestResponseType === BentoContactResponseType.wrong_location ||
    bentoContact.bestResponseType === BentoContactResponseType.interested
  );
};

export const getSourceLabel = (bentoBrand: BentoBrand) => {
  const isAdmin = Boolean(sessionStorage.getItem(ON_BEHALF_OF_TOKEN));

  if (bentoBrand?.isAdmin) {
    return "From Virtual Assistant";
  } else if (bentoBrand?.createdByAutomation) {
    return "From Automation";
  } else {
    return isAdmin ? "From User" : "";
  }
};

export const getLocation = (profile?: OrganizationProfile | null) => {
  let formattedString = "";
  if (profile?.addressComponents) {
    const city = profile?.addressComponents?.find((x) =>
      x.types?.includes("locality"),
    )?.longText;
    if (city) {
      formattedString += city;
    }
    const country = profile?.addressComponents?.find((x) =>
      x.types?.includes("country"),
    )?.longText;
    if (country) {
      if (city) {
        formattedString += `, ${country}`;
      } else {
        formattedString += country;
      }
    }
  }
  return formattedString;
};

export const FREE_NICHES = 2;
